import React from "react";

const Top = () => {
  return (
    <header className="Top-header">
      <img
        className="hotel-front"
        src="../images/hotelfront.jpg"
        alt="Hotelfront Logo"
      />
    </header>
  );
};

export default Top;
